import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/appsec/page.tsx");
